import { printHTML, downloadWord } from '../utils/printHelper';
import { useState, useEffect } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { Printer, FileDoc } from '@phosphor-icons/react';
import { api } from '../App';
import { DateInput } from '../components/DateInput';
import { toast } from 'sonner';
import ClientAutocomplete from '../components/ClientAutocomplete';

export default function MobingPage() {
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({
    client_id: '',
    naziv_drustva: '',
    grad: 'Ulcinj',
    datum: new Date().toISOString().split('T')[0],
    posrednik: '',
  });
  const [radnici, setRadnici] = useState([]);
  const [loadingRadnici, setLoadingRadnici] = useState(false);

  useEffect(() => {
    api.get('/clients').then(r => setClients(r.data.sort((a, b) => (a.skraceni_naziv || '').localeCompare(b.skraceni_naziv || ''))));
  }, []);

  const fetchAktivniRadnici = async (clientId) => {
    setLoadingRadnici(true);
    try {
      const r = await api.get(`/prijava-radnika?client_id=${clientId}&status=aktivan`);
      setRadnici(r.data);
      if (r.data.length > 0) toast.success(`Učitano ${r.data.length} aktivnih radnika`);
    } catch { toast.error('Greška'); }
    finally { setLoadingRadnici(false); }
  };

  const handleClientSelect = (clientId) => {
    const c = clients.find(cl => cl.id === clientId);
    if (c) {
      setForm(prev => ({
        ...prev,
        client_id: clientId,
        naziv_drustva: c.naziv_firme || c.skraceni_naziv || '',
        grad: c.grad || 'Ulcinj',
      }));
      fetchAktivniRadnici(clientId);
    }
  };

  const formatDatePrint = (d) => {
    if (!d) return '___________';
    const parts = d.split('-');
    if (parts.length === 3) return `${parts[2]}.${parts[1]}.${parts[0]}`;
    return d;
  };

  const generateMobingHtml = () => {
    return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Obavještenje o mobingu - ${form.naziv_drustva}</title>
<style>
@page{size:A4;margin:18mm 22mm}
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:Arial,Helvetica,sans-serif;font-size:12pt;color:#000;line-height:1.6}
.header{font-size:11pt;margin-bottom:8px}
p{font-size:12pt;line-height:1.6;margin:6px 0;text-align:justify}
.title{text-align:center;font-weight:bold;font-size:14pt;margin:16px 0 4px;text-transform:uppercase}
.subtitle{text-align:center;font-size:12pt;margin-bottom:14px;font-weight:bold}
.section{margin:8px 0}
.bold{font-weight:bold}
ul{margin:4px 0 4px 20px}
li{margin:3px 0;font-size:11.5pt;line-height:1.5}
ul ul{margin:2px 0 2px 16px}
ul ul li{font-size:11pt}
.posrednik{font-weight:bold;font-size:12pt;margin:8px 0}
.sign-area{display:flex;justify-content:space-between;margin-top:30px;font-size:11pt}
.sign-block{text-align:center}
.sign-line{border-top:1px solid #000;min-width:150px;padding-top:3px;margin-top:30px}
@media print{body{margin:0}}
</style></head><body>

<div class="header">
Na osnovu Zakona o zabrani zlostavljanja na radu ZAKON O ZABRANI ZLOSTAVLJANJA NA RADU ("Službeni list Crne Gore", br. 030/12 od 08.06.2012, 054/16 od 15.08.2016, 74/2019) | Pravilnika o pravilima ponašanja poslodavca i zaposlenog o prevenciji i zaštiti od zlostavljanja na radu ("Službeni list CG" broj 56/12) "${form.naziv_drustva}" za zaposlene:
</div>

<div class="title">OBAVJEŠTENJE</div>
<div class="subtitle">O zabrani zlostavljanja na radu, obavezama i odgovornostima<br>u vezi sa vršenjem mobinga, načinom prepoznavanja i<br>mogućnosti zaštite od mobinga</div>

<p>Mobing, je svako aktivno ili pasivno ponašanje na radu ili u vezi sa radom prema zaposlenom ili grupi zaposlenih, koje se ponavlja, a koje ima za cilj ili predstavljanje povredu dostojanstva, ugleda, ličnog i profesionalnog integriteta zaposlenog i koje izaziva strah ili stvara neprijateljsko, ponižavajuće ili uvredljivo okruženje, pogoršava uslove rada ili dovodi do toga da se zaposleni izoluje ili navede da na sopstvenu inicijativu otkaže ugovor o radu ili drugi ugovor.</p>

<p>Zlostavljanje-mobing je svako podsticanje ili navođenje drugih na navedeno ponašanje.</p>

<p class="bold">Izvršilac zlostavljanja može biti:</p>
<ul>
<li>Poslodavac sa svojstvom fizičkog lica sa kojim zaposleni dolazi u kontakt prilikom obavljanja poslova na radnom mjestu.</li>
<li>Odgovorno lice kod poslodavca sa svojstvom pravnog lica;</li>
<li>Zaposleni ili grupa zaposlenih kod poslodavca.</li>
<li>Treće lice sa kojim zaposleni ili poslodavac dolazi u kontakt prilikom obavljanja poslova na radnom mjestu.</li>
</ul>

<p>Zaposleni koji smatra da je izložen mobingu podnosi pisani zahtjev za pokretanje postupka za zaštitu od mobinga posredniku. Pisani zahtjev se podnosi posredniku koji posreduje među stranama u sporu koji se odnosi na mobing.</p>

<p class="posrednik">Posrednik je ${form.posrednik}.</p>
<p>Postupak posredovanja je hitan.</p>

<p>Rok za okončanje postupka posredovanja je 8 dana a može se podužiti, zbog opravdanih razloga, najviše do 30 dana od dana pokretanja postupka.</p>

<p>Zaposleni koji nije zadovoljan ishodom postupka zaštite od mobinga kod poslodavca može pokrenuti postupak za zaštitu od mobinga kod Agencije za mirno rješavanje radnih sporova ili kod nadležnog suda, u roku od 15 dana od dana dostavljanja obavještenja, odnosno zaključaka, kao i u drugim slučajevima predviđenim Zakonom.</p>

<p>Zloupotrebu prava na zaštitu od mobinga čini zaposleni koji je znao ili je morao da zna da ne postoje razlozi za pokretanje postupka za zaštitu od mobinga, a pokrene ili inicira pokretanje tog postupka, sa ciljem da za sebe ili drugog pribavi materijalnu ili nematerijalnu korist ili da nanese štetu drugom licu.</p>

<p>Zaposleni koji vrši mobing, odnosno ne prijavi ponašanje koje može predstavljati mobing ili zloupotrijebi pravo na zaštitu od mobinga odgovoran je za nepoštovanje radne discipline, odnosno povredu radne dužnosti.</p>

<p>Svu pravnu odgovornost za izvršeni mobing snosi Poslodavac sa kojim zaposleni dolazi u direktni kontakt prilikom obavljanja poslova na radnom mjestu.</p>

<p class="bold">Poslodavac treba da:</p>
<ol style="margin:4px 0 4px 20px">
<li>obezbijedi radnu okolinu u kojoj će se poslovi obavljati u atmosferi poštovanja, saradnje, otvorenosti, bezbjednosti, i jednakosti,</li>
<li>razvija svijest kod zaposlenog o potrebi uzajamnog poštovanja, saradnje i timskog rada u izvršavanju radnih zadataka,</li>
<li>pruži dobar primjer tako što će se prema svima ponašati ljubazno, sa dostojanstvom i uz dužno poštovanje,</li>
<li>omogući sindikatima da svojim učešćem daju doprinos u osposobljavanju i radu na prevenciji i sprječavanju mobinga,</li>
<li>omogući zaposlenom da iznese svoje mišljenje, stavove i predloge u vezi sa obavljanjem posla, kao i da se njegovo mišljenje sasluša i da zbog toga trpi štetne posljedice.</li>
</ol>

<p class="bold">Zaposleni treba da:</p>
<ol style="margin:4px 0 4px 20px">
<li>se prema drugim zaposlenim i poslodavcu ponasa sa dostojanstvom, poštovanjem i uvažavanjem,</li>
<li>ličnim primjerom doprinese stvaranju radne okoline u kojoj nema mobinga, kao ni ponašanja koje bi moglo da doprinese mobingu, odnosno da poslove obavlja u atmosferi poštovanja, saradnje, otvorenosti, bezbjednosti i jednakosti,</li>
<li>svojim učešćem daje doprinos u radu na prevenciji i sprječavanju mobinga,</li>
<li>prije pokretanja postupka za zaštitu od mobinga, ako je to u konkretnom slučaju izvodljivo i moguće, jasno stavi do znanja licu za koje smatra da vrši mobing da je njegovo ponašanje neprihvatljivo i da će potražiti zakonsku zaštitu ako takvo ponašanje odmah ne prestane;</li>
<li>ukoliko pokrene postupak za zaštitu od mobinga u zahtjevu navede: podatak o zaposlenom koji se tereti za mobing, kratak opis ponašanja za koje se vjeruje da predstavlja mobing, trajanje i učestalost tog ponašanja koje se smatra mobingom, datum kada je poslednji put učinjeno to ponašanje, kao i dokaze (svjedoci, pisana dokumentacija, ljekarski izvještaji, dozvoljeni audio i video zapisi i dr.).</li>
</ol>

<p class="bold">Radi prevencije i zaštite od mobinga poslodavac i zaposleni treba da izbjegavaju ponašanja koja:</p>

<ol style="margin:4px 0 4px 20px">
<li>se odnose na nemogućnost odgovarajućeg komuniciranja, kao što su:
<ul>
<li>neopravdano i namjerno onemogućavanje zaposlenog da iznese svoje mišljenje, kao i neopravdano prekidanje zaposlenog u govoru,</li>
<li>obraćanje uz viku, prijetnju i vrijeđanje,</li>
<li>uznemiravanje zaposlenog putem telefonskih poziva i drugih sredstava za komunikaciju, ako to nije u vezi sa radnim procesom i poslom koji zaposleni obavlja;</li>
</ul></li>
<li>mogu da dovedu do narušavanja dobrih međuljudskih odnosa, kao što su:
<ul>
<li>ignorisanje prisustva zaposlenog, odnosno ako se zaposleni namjerno i neopravdano izoluje od drugih zaposlenih tako što se izbjegava i prekida komunikacija sa njim,</li>
<li>neopravdana fizička izolacija zaposlenog iz radne okoline,</li>
<li>neopravdano oduzimanje zaposlenom sredstava potrebnih za obavljanje posla,</li>
<li>neopravdano nepozivanje na zajedničke sastanke,</li>
<li>neopravdana zabrana komuniciranja sa zaposlenim;</li>
</ul></li>
<li>mogu da dovedu do narušavanja ličnog ugleda zaposlenog, kao što su:
<ul>
<li>verbalno napadanje, širenje neistina o zaposlenom uopšte i u vezi sa njegovim privatnim životom,</li>
<li>negativno komentarisanje ličnih karakteristika zaposlenog,</li>
<li>imitiranje glasa, gestova i načina kretanja zaposlenog,</li>
<li>ponižavanje zaposlenog pogrdnim i degradirajućim riječima;</li>
</ul></li>
<li>mogu da dovedu do narušavanja profesionalnog integriteta zaposlenog, kao što su:
<ul>
<li>nedavanje radnih zadataka zaposlenom, koje nije opravdano potrebama procesa rada,</li>
<li>neopravdano onemogućavanje zaposlenog da izvršava radne zadatke,</li>
<li>davanje ponižavajućih radnih zadataka koji su ispod nivoa kvalifikacije zaposlenog,</li>
<li>davanje teških zadataka ili onih koji su iznad nivoa kvalifikacije zaposlenog,</li>
<li>određivanje neprimjerenih rokova za izvršavanje radnih zadataka,</li>
<li>neravnomjeran raspored radnih zadataka u odnosu na druge zaposlene koji obavljaju istu vrstu poslova,</li>
<li>česta promjena radnih zadataka ili neopravdana prekidanja u radu, koja nijesu uslovljena procesom rada,</li>
<li>neopravdano prekomjerno nadziranje rada,</li>
<li>namjerno i neopravdano uskraćivanje ili zadržavanje informacija koje su u vezi sa radom,</li>
<li>neopravdana ili prekomjerna upotreba kamera i drugih tehničkih sredstava kojima se omogućava kontrola zaposlenih,</li>
<li>neopravdano i namjerno isključivanje iz stručnog osposobljavanja i usavršavanja;</li>
</ul></li>
<li>mogu da dovedu do narušavanja zdravlja zaposlenog, kao što su:
<ul>
<li>neopravdane stalne prijetnje (npr. raskidom radnog odnosa, odnosno otkazom ugovora o radu ili drugog ugovora) i pritisci kojima se zaposleni drži u stalnom strahu,</li>
<li>prijetnja da će se protiv zaposlenog primijeniti fizička sila,</li>
<li>fizičko uznemiravanje koje nema elemente krivičnog djela,</li>
<li>namjerno izazivanje konflikata i stresa;</li>
</ul></li>
<li>bi se mogla smatrati uznemiravanjem, kao što su:
<ul>
<li>neželjeno ponašanje prema zaposlenom ili licu koje traži zaposlenje, s obzirom na pol, rođenje, jezik, rasu, vjeru, boju kože, starost, trudnoću, zdravstveno stanje, odnosno invalidnost, nacionalnost, bračni status, porodične obaveze, seksualno opredjeljenje, političko ili drugo uvjerenje, socijalno porijeklo, imovno stanje, članstvo u političkim i sindikalnim organizacijama ili neko drugo lično svojstvo;</li>
</ul></li>
<li>bi se mogla smatrati seksualnim uznemiravanjem, kao što su:
<ul>
<li>ponižavajući i neprimjereni komentari i postupci seksualne prirode,</li>
<li>pokušaj ili izvršenje nepristojnog i neželjenog fizičkog kontakta,</li>
<li>navođenje na prihvatanje ponašanja seksualne prirode uz obećavanje nagrade, prijetnju ili ucjenu i dr.</li>
</ul></li>
</ol>

<div class="sign-area">
<div class="sign-block">
${form.grad.toUpperCase()}, ${formatDatePrint(form.datum)} god.
</div>
<div class="sign-block">
Poslodavac,
<div class="sign-line">_____________</div>
</div>
</div>

</body></html>`;
  };

  const handlePrint = () => {
    if (!form.posrednik) { toast.error('Izaberite posrednika'); return; }
    printHTML(generateMobingHtml());
  };

  const handleWord = () => {
    if (!form.posrednik) { toast.error('Izaberite posrednika'); return; }
    downloadWord(generateMobingHtml(), `Mobing_${(form.naziv_drustva || '').replace(/\s+/g, '_')}.docx`);
  };

  return (
    <div className="space-y-4" data-testid="mobing-page">
      <Card className="p-4 bg-white border-slate-200">
        <h3 className="text-sm font-bold text-slate-700 mb-3">Obavještenje o zabrani zlostavljanja na radu (Mobing)</h3>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Klijent</Label>
            <ClientAutocomplete clients={clients} value={form.client_id} onChange={(id) => (handleClientSelect)(id || 'none')} placeholder="Pretraga po nazivu ili PIB-u..." />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Naziv društva</Label>
            <Input value={form.naziv_drustva} onChange={e => setForm({...form, naziv_drustva: e.target.value})} className="bg-white border-slate-300 text-sm" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Grad</Label>
            <Input value={form.grad} onChange={e => setForm({...form, grad: e.target.value})} className="bg-white border-slate-300 text-sm" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Datum</Label>
            <DateInput value={form.datum} onChange={e => setForm({...form, datum: e.target.value})} className="border-slate-300 text-sm" />
          </div>
          <div className="col-span-2 space-y-1">
            <Label className="text-xs text-slate-500 font-semibold">Posrednik (aktivni radnik) *</Label>
            {radnici.length > 0 ? (
              <Select value={form.posrednik} onValueChange={v => setForm({...form, posrednik: v})}>
                <SelectTrigger className="bg-white border-slate-300 text-sm"><SelectValue placeholder="Izaberite posrednika iz spiska aktivnih radnika" /></SelectTrigger>
                <SelectContent>
                  {radnici.map(r => {
                    const name = `${(r.prezime || '').toUpperCase()} ${(r.ime || '').toUpperCase()}`.trim();
                    return name ? <SelectItem key={r.id} value={name}>{name} - {r.naziv_radnog_mjesta || ''}</SelectItem> : null;
                  })}
                </SelectContent>
              </Select>
            ) : (
              <Input value={form.posrednik} onChange={e => setForm({...form, posrednik: e.target.value})} placeholder={loadingRadnici ? 'Učitavam radnike...' : 'Unesite ime posrednika ili izaberite klijenta'} className="bg-white border-slate-300 text-sm" />
            )}
          </div>
        </div>
      </Card>

      <div className="flex gap-2">
        <Button onClick={handlePrint} className="bg-slate-800 hover:bg-slate-700 text-sm" disabled={!form.client_id || !form.posrednik}>
          <Printer size={16} className="mr-2" /> Štampaj
        </Button>
        <Button onClick={handleWord} className="bg-indigo-600 hover:bg-indigo-700 text-sm text-white" disabled={!form.client_id || !form.posrednik}>
          <FileDoc size={16} className="mr-2" /> Word
        </Button>
      </div>
    </div>
  );
}
